/**
 * Checks if all data values in the chart data are zero
 * @param {Object} chartData - The chart data object
 * @returns {boolean} - True if all data values are zero, false otherwise
 */
const hasZeroData = (chartData) => {
  if (!chartData) {
    return false; // No data means we should show loading, not "no data"
  }

  // If there are no datasets, it's not a chart that should show "no data"
  if (!chartData.datasets || !Array.isArray(chartData.datasets)) {
    return false;
  }

  // Check if all datasets have zero values
  const allDatasetsHaveZeroData = chartData.datasets.every(dataset => {
    if (!dataset.data || !Array.isArray(dataset.data)) {
      return true;
    }
    
    // Check if all values in the dataset are zero
    return dataset.data.every(value => value === 0 || value === null || value === undefined);
  });

  // Only return true if we have datasets and all are zero
  return allDatasetsHaveZeroData && chartData.datasets.length > 0;
};

export default hasZeroData;



// WEBPACK FOOTER //
// ./utils/hasZeroData.js